import * as CONSTANTS from '../constants'

const initialState = {
  loading: false,
  user: null,
  token: null,
  notifications: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.PERSIST_USER_DATA:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
      }
    case CONSTANTS.LOGIN_USER:
      return {
        ...state,
        token: action.token,
        user: action.user
      }
    case CONSTANTS.LOGOUT_USER:
      return {
        ...state,
        token: action.token,
        user: action.user
      }
    case CONSTANTS.UPDATE_USER:
      return {
        ...state,
        user: action.user,
        notifications: action.notifications
      }
    default:
      return state
  }
}